export default __webpack_public_path__ + "static/media/rtr-200-4v-moto.8ae8ec6f.png";